import React from 'react';
import ListarPendienteFacturar from '../../../components/insumos/informes/ListarPendienteFacturar';
import { PageWrapper } from '../../../components/common';

const ListarPendienteFacturarPage: React.FC = () => {
  return (
    <PageWrapper>
      <ListarPendienteFacturar />
    </PageWrapper>
  );
};

export default ListarPendienteFacturarPage;
